import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { auth } from "./firebase";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import { theme } from "../styles/theme";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("Login bem-sucedido");
      navigate("/");
    } catch (error) {
      console.error("Erro ao fazer login:", error.message);
      setError("E-mail ou senha inválidos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(135deg, ${theme.colors.primary}15, ${theme.colors.secondary}15)`,
        display: "flex",
      alignItems: "center",
        justifyContent: "center",
      padding: theme.spacing.xl,
      fontFamily: theme.typography.fontFamily.primary,
    }}>
      <div style={{
          width: "100%",
        maxWidth: window.innerWidth < 768 ? "95%" : "450px",
        padding: window.innerWidth < 768 ? theme.spacing.md : 0,
      }}>
        {/* Header */}
        <div style={{
            textAlign: "center",
          marginBottom: theme.spacing['2xl'],
        }}>
          
          <h1 style={{
            fontSize: theme.typography.fontSize['3xl'],
            fontWeight: theme.typography.fontWeight.bold,
            color: theme.colors.gray[800],
            marginBottom: theme.spacing.sm,
          }}>
          Bem-vindo de volta!
          </h1>
          <p style={{
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.gray[600],
          }}>
            Entre na sua conta para continuar
          </p>
        </div>

        {/* Login Form */}
        <Card variant="elevated" padding="xl">
        <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <div style={{ marginBottom: theme.spacing.lg }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                  fontSize: theme.typography.fontSize.sm,
                  fontWeight: theme.typography.fontWeight.semibold,
                  color: theme.colors.gray[700],
                  marginBottom: theme.spacing.sm,
              }}
            >
                E-mail
            </label>
              <div style={{ position: "relative" }}>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
                  placeholder="seu@email.com"
              style={{
                width: "100%",
                    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
                    border: `1px solid ${theme.colors.gray[300]}`,
                    borderRadius: theme.borderRadius.lg,
                    fontSize: theme.typography.fontSize.base,
                    fontFamily: theme.typography.fontFamily.primary,
                    transition: theme.transitions.normal,
                    backgroundColor: theme.colors.white,
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = theme.colors.primary;
                    e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}20`;
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = theme.colors.gray[300];
                    e.target.style.boxShadow = "none";
                  }}
                />
                <div style={{
                  position: "absolute",
                  right: theme.spacing.md,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: theme.colors.gray[400],
                }}>
                  📧
                </div>
              </div>
          </div>

            {/* Password Field */}
            <div style={{ marginBottom: theme.spacing.lg }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                  fontSize: theme.typography.fontSize.sm,
                  fontWeight: theme.typography.fontWeight.semibold,
                  color: theme.colors.gray[700],
                  marginBottom: theme.spacing.sm,
              }}
            >
                Senha
            </label>
              <div style={{ position: "relative" }}>
            <input
              id="password"
                  type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
                  placeholder="••••••••"
              style={{
                width: "100%",
                    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
                    paddingRight: "3rem",
                    border: `1px solid ${theme.colors.gray[300]}`,
                    borderRadius: theme.borderRadius.lg,
                    fontSize: theme.typography.fontSize.base,
                    fontFamily: theme.typography.fontFamily.primary,
                    transition: theme.transitions.normal,
                    backgroundColor: theme.colors.white,
                    boxSizing: "border-box",
              }}
                  onFocus={(e) => {
                    e.target.style.borderColor = theme.colors.primary;
                    e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}20`;
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = theme.colors.gray[300];
                    e.target.style.boxShadow = "none";
                  }}
                />
          <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
            style={{
                    position: "absolute",
                    right: theme.spacing.md,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
              border: "none",
              cursor: "pointer",
                    color: theme.colors.gray[400],
                    fontSize: theme.typography.fontSize.lg,
                    padding: theme.spacing.xs,
                    borderRadius: theme.borderRadius.sm,
                    transition: theme.transitions.normal,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = theme.colors.gray[100];
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
            }}
          >
                  {showPassword ? "🙈" : "👁️"}
          </button>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div style={{
                backgroundColor: `${theme.colors.error}10`,
                border: `1px solid ${theme.colors.error}30`,
                color: theme.colors.error,
                padding: theme.spacing.md,
                borderRadius: theme.borderRadius.md,
                marginBottom: theme.spacing.lg,
                fontSize: theme.typography.fontSize.sm,
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
              }}>
                <span>⚠️</span>
                {error}
              </div>
            )}

            {/* Submit Button */}
            <Button
              type="submit"
              variant="primary"
              size="lg"
              loading={loading}
              fullWidth
              style={{ marginBottom: theme.spacing.lg }}
            >
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          {/* Divider */}
          <div style={{
            display: "flex",
            alignItems: "center",
            margin: `${theme.spacing.lg} 0`,
          }}>
            <div style={{
              flex: 1,
              height: "1px",
              backgroundColor: theme.colors.gray[200],
            }} />
            <span style={{
              padding: `0 ${theme.spacing.md}`,
              color: theme.colors.gray[500],
              fontSize: theme.typography.fontSize.sm,
            }}>
              ou
            </span>
            <div style={{
              flex: 1,
              height: "1px",
              backgroundColor: theme.colors.gray[200],
            }} />
          </div>

          {/* Register Link */}
          <div style={{ textAlign: "center" }}>
            <p style={{
              fontSize: theme.typography.fontSize.base,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.md,
            }}>
              Não tem uma conta?
            </p>
            <Link to="/register" style={{ textDecoration: "none" }}>
              <Button variant="outline" fullWidth>
                Criar conta
              </Button>
            </Link>
          </div>
        </Card>

        {/* Footer */}
        <div style={{
          textAlign: "center",
          marginTop: theme.spacing.xl,
          color: theme.colors.gray[500],
          fontSize: theme.typography.fontSize.sm,
        }}>
          <p>
            Ao entrar, você concorda com nossos{" "}
            <span style={{ color: theme.colors.primary, cursor: "pointer" }}>
              Termos de Serviço
            </span>{" "}
            e{" "}
            <span style={{ color: theme.colors.primary, cursor: "pointer" }}>
              Política de Privacidade
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
